import React from 'react';

import { TagsContainer, Tag } from './styles';

export default function Tags({ tags, size, singleLine, tagColor, isTestTag }) {
  return (
    <TagsContainer size={size} singleLine={singleLine} isTestTag={isTestTag}>
      {tags.map((tag) => (
        <Tag key={tag} size={size} tagColor={tagColor} isTestTag={isTestTag}>
          {tag}
        </Tag>
      ))}
    </TagsContainer>
  );
}
